export const ADMIN = "admin";
export const APP_LOGO = "appLogo";
export const BASE_URL = process.env.PUBLIC_URL
  ? // Check if public url is for root folder
    process.env.PUBLIC_URL === "."
    ? // If so use empty string
      ""
    : // Otherwise use provided value
      process.env.PUBLIC_URL
  : // Fallback is empty string
    "";
export const CANDIDATE = "candidate";
export const FALLBACK_LNG = "en-GB";
export const FALLBACK_LNG_NAME = "English";
export const THEME_STYLE = "themeStyle";
export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];
